import { getAppStore } from '@/store';
import { ScreenType } from '@/types/analytics';
import { Screen } from '@/types';

const getScreenType = (): ScreenType => {
  const { screen, resultFile } = getAppStore();

  switch (screen) {
    case Screen.Library:
      return ScreenType.CHOOSER;
    case Screen.Create:
      return resultFile ? ScreenType.PREVIEW : ScreenType.GENERATOR;
    case Screen.Files:
      return ScreenType.HISTORY;
    case Screen.Loading:
      return ScreenType.GENERATOR;
    default:
      return ScreenType.GENERATOR;
  }
};

export default getScreenType;
